import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function OpeningHook() {
  return <section className="py-20 bg-white relative" data-id="element-117">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-118">
        <FadeIn data-id="element-119">
          <div className="relative pl-8 md:pl-12 border-l-4 border-sage" data-id="element-120">
            <p className="text-xl md:text-2xl leading-relaxed text-brown/90 mb-6" data-id="element-121">
              Son las 7:00 AM. Abres el cajón de los pantalones, eliges esos que
              antes te quedaban perfectos, y sucede lo de siempre:{' '}
              <span className="font-semibold" data-id="element-122">el botón no cierra.</span>
            </p>
            <p className="text-xl md:text-2xl leading-relaxed text-brown/90 mb-6" data-id="element-123">
              No es por lo que comiste ayer. De hecho, te cuidas más que nunca.
              Pero tu vientre se siente duro, inflamado y pesado.{' '}
              <span className="italic" data-id="element-124">
                Como si tu cuerpo estuviera protegiendo algo.
              </span>
            </p>
            <p className="text-xl md:text-2xl leading-relaxed text-brown/90 font-serif" data-id="element-125">
              Sientes que, hagas lo que hagas, esa "panza de estrés" no se
              mueve.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}